import {Routes} from "@angular/router";
import {dashboardRoutes} from "./dashboard";
import {CanDashboardPageDeactivate} from "@pages/dashboard";
import {settingsRoutes} from "./settings";

enum Paths {
    DASHBOARD = "dashboard",
    CHARTS = "charts",
    LOGS = "logs",
    NOTIFICATIONS = "notifications-center",
    REPORTS = "reports",
    LOGBOOKS = "logbooks",
    MY_STATIONS = "my-stations",
}

const DashboardPageComponent = () => import("@pages/dashboard/ui/dashboard-page/dashboard-page.component").then(x => x.DashboardPageComponent);
const ChartsPageComponent = () => import("@pages/charts/ui/charts-page/charts-page.component").then(m => m.ChartsPageComponent);
const NotificationsCenterPageComponent = () => import("@pages/notifications-center/ui/notifications-center-page/notifications-center-page.component").then(m => m.NotificationsCenterPageComponent);
const ReportsPageComponent = () => import("@pages/reports/ui/reports-page/reports-page.component").then(m => m.ReportsPageComponent);
const LogbooksPageComponent = () => import("@pages/logbooks/ui/logbooks-page/logbooks-page.component").then(m => m.LogbooksPageComponent);
const MyStationsPageComponent = () => import("@pages/my-stations/ui/my-stations-page/my-stations-page.component").then(m => m.MyStationsPageComponent);


export const stationRoutes: Routes = [
    {
        path: Paths.DASHBOARD,
        loadComponent: DashboardPageComponent,
        children: dashboardRoutes,
        canDeactivate: [CanDashboardPageDeactivate]
    },
    {
        path: Paths.CHARTS,
        loadComponent: ChartsPageComponent
    },
    {
        path: Paths.REPORTS,
        loadComponent: ReportsPageComponent,
    },
    {
        path: Paths.NOTIFICATIONS,
        loadComponent: NotificationsCenterPageComponent
    },
    {
        path: Paths.LOGBOOKS,
        loadComponent: LogbooksPageComponent
    },
    {
        path: Paths.MY_STATIONS,
        loadComponent: MyStationsPageComponent,
    },
];
